module.exports = __webpack_public_path__ + "assets/images/scene-3_567aedfc6f1aea65ba664ca9c2495c98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-one/croma-abeldo-dialogs/scene-3.png
// module id = 202
// module chunks = 0